import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent
  from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment-timezone'
import store from '@/store'
import deepDiff from 'deep-diff';
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import axios from '@axios'
import useFilterCounter from '@/components/Filters/useFiltersCount'
import { debounce } from 'lodash'

export default function useList() {
  store.dispatch('log_messages/getAll')
  store.dispatch('user/getAll')
  store.dispatch('tenant/getAll')
  const userData = JSON.parse(localStorage.getItem('userData'))
  const refListTable = ref(null)
  const toast = useToast()
  const startDate = ref(moment().subtract(1, 'month').format('YYYY-MM-DD HH:mm'))
  const endDate = ref(moment().format('YYYY-MM-DD HH:mm'))
  const messageOptions = computed(() => store.getters['log_messages/getSelectedItems'])
  const messageFilter = ref(null)
  const userOptions = computed(() => store.getters['user/getSelectedItems'])
  const userFilter = ref(null)
  const tenantOptions = computed(() => store.getters['tenant/getSelectedItems'])
  const tenantFilter = ref(null)
  const actionFilter = ref(null)

  const loadingToast = ref(null);
  const { t, tc } = useI18nUtils();
  const trans = {
    "messages.export.download": t("messages.export.download"),
    "messages.export.Generating_file": t("messages.export.Generating_file"),
    "messages.error.server_error": t("messages.error.server_error"),
    "messages.delete.title": t("messages.delete.title"),
    "messages.delete.body": t("messages.delete.body"),
    "actions.delete": t("actions.delete"),
    "actions.cancel": t("actions.cancel"),
    "tenant.title": tc("tenants.title", 1),
    "log_microservice.load_error": t("log_microservice.load_error"),
    report_of: t("messages.export.report"),
    full_download: t("messages.export.full_download"),
  };

  const actionOptions = [
    { label: "CREATE", value: "CREATE" },
    { label: "UPDATE", value: "UPDATE" },
    { label: "DELETE", value: "DELETE" },
    { label: "LOGIN", value: "LOGIN" },
    { label: "GET", value: "GET" },
    { label: "POST", value: "POST" },
    { label: "SYNC_DEVICES", value: "SYNC_DEVICES" },
    { label: "ARM_PANEL", value: "ARM_PANEL" },
    { label: "DISARM_PANEL", value: "DISARM_PANEL" },
    { label: "ARM_AREA", value: "ARM_AREA" },
    { label: "DISARM_AREA", value: "DISARM_AREA" },
    { label: "RESET_ZONE", value: "RESET_ZONE" },
    { label: "BYPASS_ZONE", value: "BYPASS_ZONE" },
    { label: "UPDATE_OUTPUT", value: "UPDATE_OUTPUT" },
    { label: "ALARM_SILENCE", value: "ALARM_SILENCE" },
    { label: "SENSOR_RESET", value: "SENSOR_RESET" },
    { label: "PTZ ACTION PERFORMED", value: "PTZ.ACTION.PERFORMED" },
    { label: "PTZ LOCK TAKEN", value: "PTZ.LOCK.TAKEN" },
    { label: "STATUS", value: "STATUS" },
    { label: "METRICS", value: "METRICS" },
    { label: "WITHOUT_TAG", value: "WITHOUT_TAG" },
    { label: "ZONE_INFORMATION", value: "ZONE_INFORMATION" },
    { label: "VIRTUAL_BYPASS_ZONE", value: "VIRTUAL_BYPASS_ZONE" },
  ]

  const levelOptions = [
    { label: "EMERGENCY", value: 0 },
    { label: "ALERT", value: 1 },
    { label: "CRITICAL", value: 2 },
    { label: "ERROR", value: 3 },
    { label: "WARNING", value: 4 },
    { label: "NOTICE", value: 5 },
    { label: "INFO", value: 6 },
    { label: "DEBUG", value: 7 }
  ]

  const levelFilter = ref(null)
  const resourseOptions = [
    { label: "ALARM", value: "ALARM" },
    { label: "DMP_PANEL", value: "DMP_PANEL" },
    { label: "DMP", value: "DMP" },
    { label: "GENERIC_DEVICE", value: "GENERIC_DEVICE" },
    { label: "PROFILE", value: "PROFILE" },
    { label: "LAYOUT", value: "LAYOUT" },
    { label: "FACILITY", value: "FACILITY" },
    { label: "CAMERA", value: "CAMERA" },
    { label: "GROUP", value: "GROUP" },
    { label: "COMMAND", value: "COMMAND" },
    { label: "TYPE_ALARM", value: "TYPE_ALARM" },
    { label: "DEVICE_INTERPHONE", value: "DEVICE_INTERPHONE" },
    { label: "GROUP.CAMERA", value: "GROUP.CAMERA" },
    { label: "VIDEO.DOWNLOAD", value: "VIDEO.DOWNLOAD" },
    { label: "SHARE_VIDEO_LINK", value: "SHARE_VIDEO_LINK" },
    { label: "COLECTOR", value: "COLECTOR" },
    { label: "CENTER", value: "CENTER" },
    { label: "PERMISSION", value: "PERMISSION" },
    { label: "VXG_MASTER_ACCOUNT", value: "VXG_MASTER_ACCOUNT" },
    { label: "SECTOR", value: "SECTOR" },
    { label: "VIEW", value: "VIEW" },
    { label: "ROUTER", value: "ROUTER" },
    { label: "ALARM_WORKFLOW", value: "ALARM_WORKFLOW" },
    { label: "CAMERA", value: "CAMERA" },
    { label: "CAMERA_MANAGER", value: "CAMERA_MANAGER" },
    { label: "CENTER", value: "CENTER" },
    { label: "COLECTOR", value: "COLECTOR" },
    { label: "COMMAND", value: "COMMAND" },
    { label: "COMMENT", value: "COMMENT" },
    { label: "DEVICE_INTERPHONE", value: "DEVICE_INTERPHONE" },
    { label: "FACILITY", value: "FACILITY" },
    { label: "GENERIC_DEVICE", value: "GENERIC_DEVICE" },
    { label: "GROUP", value: "GROUP" },
    { label: "GROUP.CAMERA", value: "GROUP.CAMERA" },
    { label: "LAYOUT", value: "LAYOUT" },
    { label: "PERMISSION", value: "PERMISSION" },
    { label: "PROFILE", value: "PROFILE" },
    { label: "ROUTER", value: "ROUTER" },
    { label: "SECTOR", value: "SECTOR" },
    { label: "SHARE_VIDEO_LINK", value: "SHARE_VIDEO_LINK" },
    { label: "TENANT", value: "TENANT" },
    { label: "TYPE_ALARM", value: "TYPE_ALARM" },
    { label: "USER", value: "USER" },
    { label: "USER.CAMERA", value: "USER.CAMERA" },
    { label: "VIDEO", value: "VIDEO" },
    { label: "VIDEO.DOWNLOAD", value: "VIDEO.DOWNLOAD" },
    { label: "VIEW", value: "VIEW" },
    { label: "OMNICLOUD_CAMERA", value: "VXG_CAMERA" },
    { label: "OMNICLOUD_MASTER_ACCOUNT", value: "VXG_MASTER_ACCOUNT" },
    { label: "DEVICE", value: "DEVICE" },
  ]
  const resourseFilter = ref(null)

  const change = computed(() => store.getters['user/getChangeTraslate'])

  const formatTenantNames = (value) => {
    if (!value) return '';
    try {
      const tenants = Array.isArray(value) ? value : [value];
      return tenants.map(tenant => tenant.name).join(', ');
    } catch (error) {
      console.error('Error formatting tenant names:', error);
      return '';
    }
  }

  let tableColumns = [
    { label: 'log_microservice.user_id', key: 'userId', sortable: true },
    { label: 'log_microservice.resource', key: 'resource', sortable: true },
    { label: 'log_microservice.target', key: 'target', sortable: true },
    { label: 'log_microservice.device', key: 'deviceId', sortable: true },
    { label: 'log_microservice.description', key: 'description', sortable: true },
    { label: 'log_microservice.action', key: 'action', sortable: true },
    { label: 'log_microservice.difference', key: 'diff', sortable: true },
    { label: 'IP Address', key: 'ipAddress', sortable: true },
    // { label: 'log_microservice.client_host', key: 'client_host', sortable: true },
    // { label: 'log_microservice.provider', key: 'provider', sortable: true },
    { label: 'log_microservice.level', key: 'level', sortable: true },
    // { label: 'log_microservice.log_message', key: 'log_message.message', sortable: true },
    {
      label: 'date.created_at',
      key: 'createdAt',
      sortable: true,
      formatter: 'formatDateAssigned'
    }
  ];

  let indexToInsert = tableColumns.findIndex(column => column.key === 'provider') + 1;

  if (userData.profile.type === "MasterAdmin") {
    tableColumns.splice(indexToInsert, 0,
      { label: 'log_microservice.message', key: 'message', sortable: true },
      { label: 'log_microservice.path', key: 'path', sortable: true },
      { label: 'log_microservice.tenant_id', key: 'tenantCat', sortable: true, formatter: 'formatTenantNames' },
    );
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const handleCreateAction = (objeto) => {
    return {
      ...objeto,
      diff: {
        diff: null,
        data: JSON.parse(objeto.data),
        action: 'CREATE',
        resource: objeto.resource,
      },
    };
  }

  const handleDeleteAction = (objeto) => {
    return {
      ...objeto,
      diff: {
        diff: null,
        data: JSON.parse(objeto.oldData),
        action: 'DELETE',
        resource: objeto.resource,
      },
    };
  }

  const handleDefaultAction = (objeto) => {
    if (objeto.data === '[]' && objeto.oldData === '[]') {
      return {
        ...objeto,
        diff: {
          diff: null,
          data: JSON.parse(objeto.data),
          oldData: JSON.parse(objeto.oldData),
          resource: objeto.resource
        },
      };
    } else {
      const diferencias = deepDiff(JSON.parse(objeto.data), JSON.parse(objeto.oldData));
      return {
        ...objeto,
        diff: {
          diff: diferencias,
          old_data: JSON.parse(objeto.oldData),
          resource: objeto.resource,
        },
      };
    }
  }

  const utcToTz = (date, tz = 'America/Mexico_City') => moment.utc(date).tz(tz);
  const toUtc = (value) => moment.tz(value, 'YYYY-MM-DD HH:mm', moment.tz.guess()).utc()

  const activeFilters = computed(() => ({
    q: searchQuery.value,
    max: perPage.value,
    'page[n]': currentPage.value,
    sortBy: sortBy.value,
    sortDesc: isSortDirDesc.value,
    message: messageFilter.value,
    user_id: userFilter.value,
    tenant_id: tenantFilter.value,
    action: actionFilter.value,
    level: levelFilter.value,
    start_at: startDate.value ? toUtc(startDate.value).format('YYYY-MM-DDTHH:mm:ss') : null,
    end_at: endDate.value ? toUtc(endDate.value).format('YYYY-MM-DDTHH:mm:ss') : null,
    resource: resourseFilter.value
  }))

  // `true` when the last fetch failed, so the table can show an error state
  // instead of the regular "no records" message
  const loadError = ref(false)

  const fetchList = (ctx, callback) => {
    loadError.value = false

    store.dispatch('microservice_logs/getAll', activeFilters.value)
      .then(response => {
        let newData = response.data;
        newData = newData.map(objeto => {

          const fieldsToReplace = ['description', 'path', 'resource', 'action', 'data', 'oldData'];

          fieldsToReplace.forEach(campo => {
            if (objeto[campo] && typeof objeto[campo] === 'string') {
              if(campo == 'data' || campo == 'oldData'){
                objeto[campo] = objeto[campo].replace(/VXG/gi, 'omnicloud');
              }
              else{
                objeto[campo] = objeto[campo].replace(/VXG/gi, 'OMNICLOUD');
              }
            }
          });

          if (objeto.tenantCat) {
            try {
              let cleanedTenantCat = objeto.tenantCat.replace(/^"|"$/g, '');
              cleanedTenantCat = cleanedTenantCat.replace(/\\"/g, '"');

              objeto.tenantCat = JSON.parse(cleanedTenantCat);

            } catch (error) {
              console.error('Error al parsear tenantCat:', error);
            }
          }

          switch (objeto.action) {
            case 'CREATE':
              return objeto.oldData === '[]' ? handleCreateAction(objeto) : objeto;
            case 'DELETE':
              return objeto.data === '[]' ? handleDeleteAction(objeto) : objeto;
            default:
              return handleDefaultAction(objeto);
          }
        });
        callback(newData);
        totalList.value = response.total
      })
      .catch(() => {
        loadError.value = true
        totalList.value = 0
        // The callback must always run: it is what clears the table's internal
        // busy state, otherwise the spinner stays forever after a failure
        callback([])
        toast({
          component: ToastificationContent, props: {
            title: trans["messages.error.server_error"],
            text: trans["log_microservice.load_error"],
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const formatDateAssigned = value => {
    const formattedDate = moment.utc(value).tz(moment.tz.guess()).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate
  }

  const refetchData = () => {
    if (!refListTable.value) return
    refListTable.value.refresh()
  }

  const buttonExport = ref(false);

  const exportExcel = () => {
    buttonExport.value = true;
    loadingToast.value.show(
      trans["messages.export.download"],
      trans["messages.export.Generating_file"],
      "secondary"
    );
    store
      .dispatch("microservice_logs/export", {
        ...activeFilters.value,
      })
      .then((response) => {
        // Logic of response in store microservice_logs-export
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: trans["messages.error.server_error"],
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
      .finally(() => {
        loadingToast.value.close();
        buttonExport.value = false;
      });
  };

  watch([currentPage, perPage, change], () => {
    refetchData()
  })

  watch([
    searchQuery
  ],
    debounce(() =>
      refetchData()
      , 500));


  // filters counter ============================
  const filters = ref({
    start_at: startDate.value,
    end_at: endDate.value,
  });
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      message: messageFilter.value,
      user_id: userFilter.value,
      tenant_id: tenantFilter.value,
      action: actionFilter.value,
      level: levelFilter.value,
      start_at: startDate.value,
      end_at: endDate.value,
      resource: resourseFilter.value
    };
    refetchData();
  }
  const clearSearchFilters = () => {
    messageFilter.value = null;
    userFilter.value = null;
    tenantFilter.value = null;
    actionFilter.value = null;
    levelFilter.value = null;
    startDate.value = null;
    endDate.value = null;
    resourseFilter.value = null;
    buildFilters();
  }
  // ============================================

  return {
    resourseOptions,
    resourseFilter,
    startDate,
    endDate,
    levelOptions,
    levelFilter,
    actionFilter,
    actionOptions,
    tenantOptions,
    tenantFilter,
    userOptions,
    userFilter,
    messageOptions,
    messageFilter,
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    refetchData,
    loadError,
    change,

    activeFilters,
    loadingToast,
    buttonExport,
    exportExcel,

    filtersCount,
    buildFilters,
    clearSearchFilters,
  }
}
